/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PuttingSplitsQueryVariables = {|
  eventID: string
|};
export type PuttingSplitsQueryResponse = {|
  +whoAmI: ?{|
    +username: string
  |},
  +grassCategories: ?$ReadOnlyArray<?{|
    +id: string,
    +categoryName: string,
  |}>,
  +pgaTourEvent: ?{|
    +tournament: {|
      +officialName: string
    |}
  |},
  +pgaEventCoursesForEvent: ?$ReadOnlyArray<?{|
    +id: string,
    +course: {|
      +name: string
    |},
    +primaryGreenGrass: ?{|
      +id: string,
      +category: {|
        +id: string,
        +categoryName: string,
      |},
    |},
  |}>,
|};
export type PuttingSplitsQuery = {|
  variables: PuttingSplitsQueryVariables,
  response: PuttingSplitsQueryResponse,
|};
*/


/*
query PuttingSplitsQuery(
  $eventID: ID!
) {
  whoAmI {
    username
    id
  }
  grassCategories {
    id
    categoryName
  }
  pgaTourEvent(eventId: $eventID) {
    tournament {
      officialName
      id
    }
    id
  }
  pgaEventCoursesForEvent(eventId: $eventID) {
    id
    course {
      name
      id
    }
    primaryGreenGrass {
      id
      category {
        id
        categoryName
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "eventID"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "categoryName",
    "storageKey": null
  }
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "PGATourGrassCategoryType",
  "kind": "LinkedField",
  "name": "grassCategories",
  "plural": true,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v5 = [
  {
    "kind": "Variable",
    "name": "eventId",
    "variableName": "eventID"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "officialName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "PGATourGrassTypeType",
  "kind": "LinkedField",
  "name": "primaryGreenGrass",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "PGATourGrassCategoryType",
      "kind": "LinkedField",
      "name": "category",
      "plural": false,
      "selections": (v3/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PuttingSplitsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserType",
        "kind": "LinkedField",
        "name": "whoAmI",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      (v4/*: any*/),
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "PGATourEventType",
        "kind": "LinkedField",
        "name": "pgaTourEvent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourTournamentType",
            "kind": "LinkedField",
            "name": "tournament",
            "plural": false,
            "selections": [
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "PGATourEventCourseType",
        "kind": "LinkedField",
        "name": "pgaEventCoursesForEvent",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourCourseType",
            "kind": "LinkedField",
            "name": "course",
            "plural": false,
            "selections": [
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PuttingSplitsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserType",
        "kind": "LinkedField",
        "name": "whoAmI",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      (v4/*: any*/),
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "PGATourEventType",
        "kind": "LinkedField",
        "name": "pgaTourEvent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourTournamentType",
            "kind": "LinkedField",
            "name": "tournament",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "PGATourEventCourseType",
        "kind": "LinkedField",
        "name": "pgaEventCoursesForEvent",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourCourseType",
            "kind": "LinkedField",
            "name": "course",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "65a412c08e1a27b076b3aa0871a8ab97",
    "id": null,
    "metadata": {},
    "name": "PuttingSplitsQuery",
    "operationKind": "query",
    "text": "query PuttingSplitsQuery(\n  $eventID: ID!\n) {\n  whoAmI {\n    username\n    id\n  }\n  grassCategories {\n    id\n    categoryName\n  }\n  pgaTourEvent(eventId: $eventID) {\n    tournament {\n      officialName\n      id\n    }\n    id\n  }\n  pgaEventCoursesForEvent(eventId: $eventID) {\n    id\n    course {\n      name\n      id\n    }\n    primaryGreenGrass {\n      id\n      category {\n        id\n        categoryName\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7f566501ac0da8460e840b168229ff5e';

module.exports = node;
